<div class="page">
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Agregar medicamento</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Medicamento</mat-label>
        <input matInput formControlName="medicamento" placeholder="Ej. Paracetamol" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Dosis</mat-label>
        <input matInput formControlName="dosis" placeholder="Ej. 500 mg" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Administración</mat-label>
        <input matInput formControlName="administracion" placeholder="Ej. Vía oral" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Indicaciones</mat-label>
        <input matInput formControlName="frecuencia" placeholder="Cada 8 horas" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Duración</mat-label>
        <input matInput formControlName="duracion" placeholder="7 días" />
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button class="add-boton" color="primary" (click)="guardar()">
      Agregar
      <mat-icon>add</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
